import React from "react";

const Keyboard = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M3.6 4h28.8c.424 0 .831.166 1.131.463.3.296.469.698.469 1.117v25.284c0 .42-.169.821-.469 1.118a1.61 1.61 0 0 1-1.131.462H3.6a1.61 1.61 0 0 1-1.131-.462A1.57 1.57 0 0 1 2 30.864V5.58c0-.419.169-.82.469-1.117A1.61 1.61 0 0 1 3.6 4Zm3.2 6.321v3.16H10v-3.16H6.8Zm0 6.321v3.16H10v-3.16H6.8Zm0 6.321v3.16h22.4v-3.16H6.8Zm6.4-6.321v3.16h3.2v-3.16h-3.2Zm0-6.321v3.16h3.2v-3.16h-3.2Zm6.4 0v3.16h3.2v-3.16h-3.2Zm6.4 0v3.16h3.2v-3.16H26Zm-6.4 6.321v3.16h3.2v-3.16h-3.2Zm6.4 0v3.16h3.2v-3.16H26Z"
            fill={fill}
        />
    </svg>
);

export default Keyboard;